"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRelativeDirection = exports.Directions = void 0;
const board_1 = require("@creature-chess/board");
exports.Directions = {
    UP: { x: 0, y: -1 },
    RIGHT: { x: 1, y: 0 },
    DOWN: { x: 0, y: 1 },
    LEFT: { x: -1, y: 0 },
};
/**
 * Returns the relative direction of position b from the perspective of position a
 *
 * @param from The position to find the direction relative from
 * @param to The position to find the direction relative to
 */
const getRelativeDirection = (from, to) => {
    const [fromX, fromY] = (0, board_1.unpackPosition)(from);
    const [toX, toY] = (0, board_1.unpackPosition)(to);
    if (fromX < toX) {
        return exports.Directions.RIGHT;
    }
    if (fromX > toX) {
        return exports.Directions.LEFT;
    }
    if (fromY < toY) {
        return exports.Directions.DOWN;
    }
    if (fromY > toY) {
        return exports.Directions.UP;
    }
    return { x: 0, y: 0 };
};
exports.getRelativeDirection = getRelativeDirection;
